import { render, staticRenderFns } from "./TcfdDataTable.vue?vue&type=template&id=0843c4cd&scoped=true"
import script from "./TcfdDataTable.vue?vue&type=script&lang=js"
export * from "./TcfdDataTable.vue?vue&type=script&lang=js"
import style0 from "./TcfdDataTable.vue?vue&type=style&index=0&id=0843c4cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0843c4cd",
  null
  
)

export default component.exports